import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@getro/rombo';
import { Flex, Box, Text } from 'rebass/styled-components';
import { Plus } from 'lucide-react';

const BlankMessage = ({ className, title, content, children, buttonText, onClick, ...rest }) => (
  <Flex flexDirection="column" alignItems="center" p="16px" data-testid="BlankMessage" {...rest}>
    {!!title.length && (
      <Text color="text.main" fontSize="14px" fontWeight="medium" lineHeight="1.2" mb="8px">
        {title}
      </Text>
    )}
    {!!content.length && (
      <Text sx={{ fontSize: '14px', color: 'text.subtle' }} dangerouslySetInnerHTML={{ __html: content }} />
    )}
    {children && <Box sx={{ fontSize: '14px', color: 'text.subtle' }}>{children}</Box>}
    {!!buttonText.length && onClick && (
      <Button mt={3} onClick={onClick} variant="secondary" size="small" data-testid="BlankMessage-button">
        <Box mr={1} height="1em" width="1em" strokeWidth="1.5" aria-hidden="true" as={Plus} />
        {buttonText}
      </Button>
    )}
  </Flex>
);

BlankMessage.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

BlankMessage.defaultProps = {
  className: '',
  title: '',
  content: '',
  buttonText: '',
  onClick: () => {},
  children: null,
};

export default BlankMessage;
